// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2wMU9","inner":"Footer_inner__2cniY"};